import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CheckboxCustom, CreateChancel, NoYet, SimpleTooltip } from 'components';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import { fundingSourceActions, httpRequestsOnSuccessActions } from 'store';
import { capabilitiesMapping, clearHousingEnums } from '../../../../system/core/constants';
import { clearingHouseTypeEnums } from '../../../createFundingSource/constant';
import { supportEnums } from '../constants';

const ACTION_TYPE = 'ADD_PAYER_ENROLLMENT';

export const AddEnrollment = ({}) => {
    const {
        handleSubmit,
        control,
        watch,
        clearErrors,
        formState: { errors },
    } = useForm();
    const payer = useSelector((state) => state.fundingSource.fundingSourceItem);
    const dispatch = useDispatch();
    const { close } = useModal();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const selected = watch('transactions') || {};
    const activeEnrollments = payer?.enrollments?.filter((i) => i?.status !== 'REJECTED' && i?.status !== 'CANCELED');
    const professionalClaimSubmission = activeEnrollments?.find((i) =>
        i?.transactions?.includes(capabilitiesMapping.PROFESSIONAL_CLAIM_SUBMISSION)
    );
    const eligibilityCheck = activeEnrollments?.find((i) => i?.transactions?.includes(capabilitiesMapping.ELIGIBILITY_CHECK));
    const claimStatus = activeEnrollments?.find((i) => i?.transactions?.includes(capabilitiesMapping.CLAIM_STATUS));
    const claimPayment = activeEnrollments?.find((i) => i?.transactions?.includes(capabilitiesMapping.CLAIM_PAYMENT));
    const payerCapabilities = useSelector((state) => state.fundingSource.payerCapabilities);
    const tlClearinghouse = payer?.payerIds?.find((i) => i.clearinghouse === clearingHouseTypeEnums.TL_CLEARINGHOUSE);
    const currentPayer = payerCapabilities?.items?.find((i) => i?.payer?.primaryPayerId === tlClearinghouse?.id);

    const capabilitiesList = [
        currentPayer?.payer?.transactionSupport?.professionalClaimSubmission === supportEnums.ENROLLMENT_REQUIRED && {
            alreadyUsed: !!professionalClaimSubmission,
            title: 'Professional Claim Submission',
            value: clearHousingEnums.PROFESSIONAL_CLAIM_SUBMISSION,
            convertedValue: 'professionalClaimSubmission',
            id: clearHousingEnums.PROFESSIONAL_CLAIM_SUBMISSION,
        },
        currentPayer?.payer?.transactionSupport?.eligibilityCheck === supportEnums.ENROLLMENT_REQUIRED && {
            alreadyUsed: !!eligibilityCheck,
            title: 'Eligibility Check',
            value: clearHousingEnums.ELIGIBILITY_CHECK,
            convertedValue: 'eligibilityCheck',
            id: clearHousingEnums.ELIGIBILITY_CHECK,
        },
        currentPayer?.payer?.transactionSupport?.claimStatus === supportEnums.ENROLLMENT_REQUIRED && {
            alreadyUsed: !!claimStatus,
            title: 'Claim Status',
            value: clearHousingEnums.CLAIM_STATUS,
            convertedValue: 'claimStatus',
            id: clearHousingEnums.CLAIM_STATUS,
        },
        currentPayer?.payer?.transactionSupport?.claimPayment === supportEnums.ENROLLMENT_REQUIRED && {
            alreadyUsed: !!claimPayment,
            title: 'Claim Payment',
            value: clearHousingEnums.CLAIM_PAYMENT,
            convertedValue: 'claimPayment',
            id: clearHousingEnums.CLAIM_PAYMENT,
        },
    ].filter(Boolean);

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success]);

    const handleCreate = (data) => {
        const transactions = Object.entries(data.transactions || {})
            .filter(([_, checked]) => checked)
            .map(([key]) => capabilitiesMapping[key]);
        dispatch(fundingSourceActions.addPayerEnrollment(payer?.id, { transactions: transactions }));
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Add Enrollment</p>
            <p className="modal-header-sub">Select the capabilities you want to enroll for this payer</p>
            <div>
                <form onSubmit={handleSubmit(handleCreate)}>
                    <div style={{ margin: '24px 0' }}>
                        {capabilitiesList?.length ? (
                            capabilitiesList?.map((item, j) => (
                                <div
                                    key={item.value}
                                    style={{
                                        padding: '9px 0',
                                        borderBottom: '1px solid #F5F5F5',
                                        opacity: item?.alreadyUsed ? 0.5 : 1,
                                    }}
                                >
                                    <Fragment>
                                        {item?.alreadyUsed ? (
                                            <SimpleTooltip title={'Capabilities already used'} placement="top-start">
                                                <div>
                                                    <CheckboxCustom
                                                        disabled={true}
                                                        color={'#D0D5DD'}
                                                        label={item.title}
                                                        name={`transactions.${item.value}`}
                                                        control={control}
                                                    />
                                                </div>
                                            </SimpleTooltip>
                                        ) : (
                                            <CheckboxCustom
                                                disabled={item?.alreadyUsed}
                                                color={errors?.transactions ? '#FE7070' : selected[item.value] ? '#0C66E4' : '#D0D5DD'}
                                                name={`transactions.${item.value}`}
                                                label={item.title}
                                                control={control}
                                                valueOnCheck={true}
                                                onClick={() => {
                                                    clearErrors('transactions');
                                                }}
                                                rules={{
                                                    validate: () => {
                                                        const values = Object.values(watch('transactions') || {}).filter(Boolean);
                                                        return values.length > 0 || 'At least one use case must be selected.';
                                                    },
                                                }}
                                            />
                                        )}
                                    </Fragment>
                                </div>
                            ))
                        ) : (
                            <NoYet text="No Capabilities Yet" />
                        )}
                    </div>

                    <CreateChancel
                        type="submit"
                        loader={!!loader.length}
                        create={'Add Enrollment'}
                        chancel={'Cancel'}
                        onClose={close}
                        buttonWidth="100%"
                        cancelRight={'24px'}
                    />
                </form>
            </div>
        </div>
    );
};
